// eslint-disable-next-line import/prefer-default-export
export const AwardingRuleParameterType = Object.freeze({
    CustomDataType: 0,
    HyperfindBelonging: 1,
    DataviewData: 2,
    // JobTransfer: 3,
    // HireDate: 4,
    BySubmittedRequestDateTime: 5,
});
